// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2JNgN","footer":"Form_footer__OSsRv"};